define('plugin/category/collection/CategoryCollection',['require','lib/collection/FilterableCollection','plugin/category/model/CategoryModel'],function (require) {
	
	var FilterableCollection = require('lib/collection/FilterableCollection');
	var CategoryModel = require('plugin/category/model/CategoryModel');
	
	/**
	 * Categories list collection
	 * 
	 * @class CategoryCollection
	 */
	return FilterableCollection.extend({
		
		url: '/ext/category/',
		model: CategoryModel
		
	});
	
});
